import type { CSSProp } from 'styled-components';
import { css } from 'styled-components';

import type { IconSize } from '@/components/Icon/Icon.types';
import { IconPixelSize } from '@/components/Icon/utils';

export const getFlagSize = (size: IconSize): CSSProp => {
  const wrapperPixelSize = IconPixelSize[size];
  const iconPixelSize = flagPixelSize[size];

  return css`
    height: ${wrapperPixelSize}px;
    width: ${wrapperPixelSize}px;
    min-width: ${wrapperPixelSize}px;

    & > span {
      width: ${iconPixelSize}px;
      height: ${iconPixelSize}px;
    }
  `;
};

const flagPixelSize: { [key in IconSize]: number } = {
  l: 20,
  m: 16,
  s: 12,
};
